module.exports = __webpack_public_path__ + "img/isacio.06cb24e6.png";